import React, {useMemo} from 'react';
import styled from 'styled-components';
import { fontSize } from '../../mixins';


const StyledOptionRow = styled.div`
  display: flex;
  align-items: center;
  display: ${(props) => props.swap ? 'none' : 'flex'};
  opacity: ${(props) => props.hide ? 1 : 0.4};
  
  &:not(:last-child) {
    margin-bottom: 24px;
  }
  
  @media screen and (max-width: 430px) {
    &:not(:last-child) {
      margin-bottom: 12px;
    }
  }
`;

const StyledImg = styled.img`
  margin-right: 16px;
  width: 53px;
  height: 53px;
`;

const StyledTitle = styled.div`
  font-weight: 700;
  ${fontSize(16)};
  line-height: 19px;
  color: #ffffff;
  margin-bottom: 2px;
`;

const StyledSubTitle = styled.span`
  font-weight: 400;
  ${fontSize(14)};
  line-height: 16px;
  color: #ffffff;
`;


const PackageOptions = ({active,promo}) => {
    const Options = useMemo(() => [
        {
            id: 0,
            src: '../images/plan_options/CheckLocationSingleCircle.png',
            title: 'Check Location',
            subtitle: 'Real-time location (inc. one member)',
        },
        {
            id: 1,
            src: '../images/plan_options/CheckLocationFamilyCircle.png',
            title: promo ? 'Real-time Location' : 'Check Location',
            subtitle: promo ? 'Live updates & history of family’s location' : 'Real-time location (inc. unlimited members)',
        },
        {
            id: 2,
            src: '../images/plan_options/PlaceAlertsCircle.png',
            title: 'Place Alerts',
            subtitle: promo ? 'Be notified when they leave or arrive home' : 'Get notified when family leaves or arrives',
        },
        {
            id: 3,
            src: '../images/plan_options/SpeedControlCircle.png',
            title: 'Speed control',
            subtitle: 'Track the car speed in real-time',
        },
        {
            id: 4,
            src: '../images/plan_options/FallDetectionCircle.png',
            title: 'Fall Detection',
            subtitle: 'Know if loved ones are getting hurt',
        },
        {
            id: 5,
            src: '../images/plan_options/DriverProtectionCircle.png',
            title: 'Driver Protection',
            subtitle: 'Know if loved ones are driving dangerously',
        },
    ],[promo]);
  
    const renderOptions = (i) => (
        <React.Fragment key={i.id}>
            <StyledOptionRow
                swap={active ? i.id === 0 : i.id === 1}
                hide={active ? i.id : i.id < 2}
            >
                <StyledImg src={i.src} alt={i.title}/>
                <div>
                    <StyledTitle>{i.title}</StyledTitle>
                    <StyledSubTitle>{i.subtitle}</StyledSubTitle>
                </div>
            </StyledOptionRow>
        </React.Fragment>
    );


    return Options.map(renderOptions);
};

export default PackageOptions;